import {
    LogisticsSiteMethod,
    ShipmentMethodResponse,
    ShippingMethod,
    SimpleShippingMethod,
} from '@lune-climate/lune'
import { FC, ReactNode } from 'react'

import { EmissionEstimationIcons } from '../emissionEstimationIcons'

import { getShippingMethodMainTypeFromValue } from './utils'

export const LegMethodIcon: FC<{
    method: ShippingMethod | LogisticsSiteMethod | ShipmentMethodResponse
}> = ({ method }) => {
    const type = getShippingMethodMainTypeFromValue(method)
    const shippingMethodToIconMap: Record<string, ReactNode> = {
        SimpleShippingMethod: EmissionEstimationIcons.truck,
        IdentifiedVesselShippingMethod: EmissionEstimationIcons.ship,
        ContainerShippingMethod: EmissionEstimationIcons.ship,
        LogisticsSiteMethod: EmissionEstimationIcons.warehouse,
        AirShippingMethod: EmissionEstimationIcons.plane,
        RoadShippingMethod: EmissionEstimationIcons.truck,
        // default value
        default: EmissionEstimationIcons.ship,
    }

    const getIconForSimpleShippingMethod = (method: SimpleShippingMethod): ReactNode => {
        if (method.includes('train') || method === 'rail') {
            return EmissionEstimationIcons.train
        } else if (method.includes('plane')) {
            return EmissionEstimationIcons.plane
        } else if (method.includes('waterway')) {
            return EmissionEstimationIcons.ship
        } else {
            return EmissionEstimationIcons.truck
        }
    }

    if (type === 'SimpleShippingMethod') {
        return <>{getIconForSimpleShippingMethod(method as SimpleShippingMethod)}</>
    } else {
        return <>{shippingMethodToIconMap[type] || shippingMethodToIconMap.default}</>
    }
}

export default LegMethodIcon
